module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p22",
      "title": "22"
    }
  }, [_c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "apricot_stuffed_french_toast"
    }
  }, [_vm._v("Apricot-Stuffed French Toast")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("6 servings (2 slices each)")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 20 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 1 Hour 15 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" loaf (8 oz) or ½ loaf (1-lb size) day-old French bread")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" oz (from 8-oz package) cream cheese, softened")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" tablespoons apricot preserves")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" teaspoon grated lemon peel")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" eggs")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¾")]), _vm._v(" cup half-and-half or milk")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" tablespoons granulated sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon vanilla")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon ground nutmeg, if desired")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" tablespoons butter, softened")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }), _vm._v(" Powdered sugar, if desired")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" Spray 13x9-inch pan with cooking spray. Cut bread crosswise into 12 (1-inch) slices. Cut horizontal slit in side of each bread slice, cutting to but not through other side.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" In medium bowl, beat cream cheese, preserves and lemon peel with electric mixer on medium speed about 1 minute or until well mixed. Spread about 2 teaspoons cream cheese mixture inside slit in each bread slice. Place stuffed bread slices in pan.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" In medium bowl, beat eggs, half-and-half, granulated sugar, vanilla, salt and nutmeg with fork or whisk until well mixed. Pour egg mixture over bread slices; turn slices carefully to coat.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" Cover; refrigerate at least 30 minutes but no longer than 24 hours. Or to freeze, wrap pan tightly. Freeze up to 3 months. Thaw in refrigerator overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" Heat oven to 425°F. Uncover or unwrap pan. Bake 20 to 25 minutes or until golden brown. Top with butter and sprinkle with powered sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 310; Total Fat 16g (Saturated Fat 8g, Trans Fat 1g); Cholesterol 145mg; Sodium 380mg; Total Carbohydrate 32g (Dietary Fiber 1g); Protein 9g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 1 Starch, 1 Other Carbohydrate, 1 High-Fat Meat, 1½ Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 2")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d10ed3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p022.vue
// module id = 114
// module chunks = 0